// extracted by mini-css-extract-plugin
export default {"option":"styles_option__kU4+J","selected":"styles_selected__eHuLZ"};